import { render, staticRenderFns } from "./BranchesFilter.vue?vue&type=template&id=5677d0ba&"
import script from "./BranchesFilter.vue?vue&type=script&lang=js&"
export * from "./BranchesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports